var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3875 2.64611L10.2667 4.58438C10.3458 4.66604 10.3458 4.79927 10.2667 4.88092L5.71667 9.57403L3.78333 9.79536C3.525 9.82545 3.30625 9.59981 3.33542 9.33336L3.55 7.33922L8.1 2.64611C8.17917 2.56446 8.30833 2.56446 8.3875 2.64611ZM11.7625 2.15402L10.7458 1.10538C10.4292 0.778756 9.91458 0.778756 9.59583 1.10538L8.85833 1.86608C8.77917 1.94773 8.77917 2.08096 8.85833 2.16262L10.7375 4.10089C10.8167 4.18255 10.9458 4.18255 11.025 4.10089L11.7625 3.34019C12.0792 3.01142 12.0792 2.48065 11.7625 2.15402ZM8 8.29761V10.4851H1.33333V3.6088H6.12083C6.1875 3.6088 6.25 3.58087 6.29792 3.53359L7.13125 2.67405C7.28958 2.51074 7.17708 2.23353 6.95417 2.23353H1C0.447917 2.23353 0 2.69554 0 3.26498V10.829C0 11.3984 0.447917 11.8604 1 11.8604H8.33333C8.88542 11.8604 9.33333 11.3984 9.33333 10.829V7.43807C9.33333 7.20814 9.06458 7.09425 8.90625 7.25541L8.07292 8.11495C8.02708 8.16438 8 8.22884 8 8.29761Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.d45555c24a694dfbf973cb8b54812f55.svg";
export { ForwardRef as ReactComponent };